// Input Sanitization
export const sanitizeInput = (input: string): string => {
  return input.trim().replace(/\s+/g, ' ');
};

export const isEmptyInput = (input: string): boolean => {
  return !input || input.trim() === '';
};

export const escapeHtml = (text: string): string => {
  const div = document.createElement('div');
  div.textContent = text;
  return div.innerHTML;
};

// Validation Rules
export const validationRules = {
  email: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
  strongPassword: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
  name: /^[a-zA-Z\s]{2,50}$/,
  phone: /^[6-9]\d{9}$/,
  searchMaxLength: 50,
};

// File Upload Validation
export const fileValidation = {
  maxSize: 5 * 1024 * 1024, // 5MB
  allowedTypes: ['image/jpeg', 'image/jpg', 'image/png', 'image/webp'],
  
  validateFile: (file: File): { isValid: boolean; error?: string } => {
    if (file.size > fileValidation.maxSize) {
      return { isValid: false, error: 'File size must be less than 5MB' };
    }
    
    if (!fileValidation.allowedTypes.includes(file.type)) {
      return { isValid: false, error: 'Only JPG, PNG, and WebP files are allowed' };
    }
    
    return { isValid: true };
  }
};

// Form Validation
export const validateForm = (fields: Record<string, any>, rules: Record<string, (value: any) => string | null>) => {
  const errors: Record<string, string> = {};
  let isValid = true;

  Object.keys(rules).forEach(field => {
    const error = rules[field](fields[field]);
    if (error) {
      errors[field] = error;
      isValid = false;
    }
  });

  return { isValid, errors };
};